<template>
  <div>
    <span
      :class="[
        'bmd-form-group d-block  form-label-group',
        focused ? 'focused' : '',
        required ? 'required' : '',
        inputHeight ? '' : 'mb-2',
      ]"
      :style="inputHeight ? { 'margin-bottom': '0px !important'} : {}"
    >
      <input
        :id="'select_' + _id"
        type="text"
        class="form-control"
        :style="{ height: inputHeight ? inputHeight : 'auto', background: disabled ? 'rgba(0,0,0,0)' : inputBackground, 'border-radius': inputBorderRadius}"
        readonly
        :disabled="disabled"
        :value="display_value"
        @click="showModal"
        :placeholder="placeholder"
      />
      <label
        :for="'select_' + _id"
        class="form-label-group-label shorter"
        :class="placeholder.indexOf('<br>') > -1 ? 'two-line' : ''"
        v-html="placeholder"
        :style="inputHeight ? { 'height': inputHeight, 'display': 'flex', 'align-items': 'center', 'gap': '10px' } : {}"
      ></label>
      <label
        :for="'select_' + _id"
        class="btn btn-default"
        style="
          position: absolute;
          right: -10px;
          top: 8px;
          left: unset;
          font-size: 0.875rem;
          padding: 0.75rem 1.25rem;
          margin-top: unset;
        "
        ><i class="fa fa-edit"></i
      ></label>
    </span>
    <b-modal
      :id="_id + 'modal'"
      size="lg"
      :title="placeholder"
      :hide-footer="true"
    >
      <div class="row mb-3">
        <div class="col-md-4" style="position: relative">
          <input
            :readonly="readonly"
            type="text"
            class="form-control"
            v-model="code_search"
            style="border-bottom-left-radius: 0; border-bottom-right-radius: 0"
          />
          <span
            class="btn btn-default text-red clear-button"
            style="position: absolute; right: 20px; top: 10px"
            @click="clear_value"
            ><i class="fa fa-times"></i
          ></span>
          <select
            @dblclick="closeModal"
            ref="code"
            :readonly="readonly"
            :id="'select_code' + _id"
            class="form-control"
            size="6"
            @click="codeChanged($event)"
            @scroll="codeScrolled($event)"
            style="
              height: 200px;
              border-top-left-radius: 0;
              border-top-right-radius: 0;
              overflow-x: auto;
            "
          >
            <option
              v-for="(value, i) in codes"
              :selected="i == selected_index"
              :key="'co' + i"
              :value="value"
            >
              {{ value }}
            </option>
          </select>
        </div>
        <div class="col-md-8">
          <input
            :readonly="readonly"
            type="text"
            class="form-control"
            v-model="value_search"
            style="border-bottom-left-radius: 0; border-bottom-right-radius: 0"
          />
          <select
            @dblclick="closeModal"
            ref="value"
            :readonly="readonly"
            :id="'select_value' + _id"
            class="form-control"
            @click="valueChanged($event)"
            @scroll="valueScrolled($event)"
            size="6"
            style="
              height: 200px;
              border-top-left-radius: 0;
              border-top-right-radius: 0;
              overflow-x: auto;
            "
          >
            <option
              v-for="(value, i) in display_texts"
              :selected="i == selected_index"
              :key="'co' + i"
              :value="value"
            >
              {{ value }}
            </option>
          </select>
        </div>
      </div>
      <!-- <button @click="save" class="btn btn-success">{{$t('message.save')}}</button> -->
      <!-- <button @click="clear_value" class="btn btn-default">{{$t('message.clear')}}</button> -->
    </b-modal>
  </div>
</template>
<script>
let Resizable = require("resizable");
export default {
  name: "v-select-popup",
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({ value: "", display_text: "" }),
    },
    indata: {
      type: Array,
      required: false,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
    not_translated: {
      type: Boolean,
      default: false,
    },
    inputHeight: {
      type: String,
      default: "",
    },
    inputBackground: {
      type: String,
      default: "rgba(0,0,0,0)",
    },
    inputBorderRadius: {
      type: String,
      default: "0.375rem",
    },
  },
  data() {
    return {
      options: [],
      options_: [],
      selected: { value: "" },
      focused: false,

      code: "",
      value_: "",
      selected_index: -1,
      code_scrolled: 0,

      code_search: "",
      value_search: "",
    };
  },
  mounted() {
    this.load("");
    this.selected = this.value;
    if (this.value.value) this.code = this.value.value;
    if (this.value.display_text) this.value_ = this.value.display_text;
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this._id + "modal");
    },
    save() {
      this.selected = { value: this.code, display_text: this.value_ };
      this.$bvModal.hide(this._id + "modal");
      this.$emit("input", this.selected);
    },
    codeValueChanged(e) {
      this.code = e.target.value;
    },
    valueScrolled(event) {
      this.code_scrolled = event.target.scrollTop;
      document.querySelector("#select_code" + this._id).scrollTop =
        this.code_scrolled;
    },
    valueChanged(event) {
      // setTimeout(()=>{
      this.selected_index = event.target.index; //Array.from(event.target.children).indexOf(event.target.querySelector('option:checked'))
      // if(this.selected_index==-1 || !this.options_filtered[this.selected_index]){
      //     this.selected_index = 0
      // }
      this.code = this.options_filtered[this.selected_index].value;
      if (event.target.querySelector("option:checked"))
        this.value_ = event.target.querySelector("option:checked").innerText;

      // this.closeModal()
      this.value_ = this.options_filtered[this.selected_index].display_text;
      // }, 500)
    },
    codeScrolled(event) {
      this.code_scrolled = event.target.scrollTop;
      document.querySelector("#select_value" + this._id).scrollTop =
        this.code_scrolled;
    },
    codeChanged(event) {
      // setTimeout(()=>{
      // console.log(event)
      this.selected_index = event.target.index; //Array.from(event.target.children).indexOf(event.target.querySelector('option:checked'))
      // if(this.selected_index==-1 || !this.options_filtered[this.selected_index]){
      //     this.selected_index = 0
      // }
      this.code = this.options_filtered[this.selected_index].value;
      if (this.options_filtered[this.selected_index])
        this.value_ = this.options_filtered[this.selected_index].display_text;

      // this.closeModal()
      // }, 500)
    },
    showModal() {
      this.$bvModal.show(this._id + "modal");
      this.code_search = "";
      this.value_search = "";

      if (this.value.value)
        this.selected_index = this.options_filtered.findIndex(
          (item) => item.value == this.value.value,
        );
      setTimeout(() => {
        this.$refs.code.querySelector("option:checked").scrollIntoView();
        this.$refs.value.querySelector("option:checked").scrollIntoView();
      }, 500);

      setTimeout(() => {
        let el0 = document.getElementById(this._id + "modal");
        el0.querySelector(".modal-dialog").classList.add("unlimited-modal");
        let previous_dimensions = window.localStorage.getItem("vsp_md");
        let el = document.getElementById(
          this._id + "modal___BV_modal_content_",
        );
        if (previous_dimensions) {
          previous_dimensions = JSON.parse(previous_dimensions);
          el.style.width = previous_dimensions.width + "px";
          el.style.height = previous_dimensions.height + "px";
          this.$refs.code.style.height =
            previous_dimensions.height - 200 + "px";
          this.$refs.value.style.height =
            previous_dimensions.height - 200 + "px";
        } else {
          el.style.width = "800px";
          el.style.height = "400px";
        }

        var resizable = new Resizable(el, {
          // within: 'document',
          handles: "s, se, e, sw, w",
          threshold: 10,
          draggable: false,
        });

        resizable.on("resize", () => {
          let width = el.offsetWidth;
          let height = el.offsetHeight;
          this.$refs.code.style.height = height - 200 + "px";
          this.$refs.value.style.height = height - 200 + "px";
          window.localStorage.setItem(
            "vsp_md",
            JSON.stringify({ width: width, height: height }),
          );
        });
      }, 100);
    },
    load(q) {
      if (this.indata.length > 0) {
        this.options = this.indata;
        if (this.not_translated) {
          this.options.forEach((item) => {
            item.display_text = this.$t(item.display_text);
          });
        }
      } else {
        axios
          .get(
            window.base +
              "/library?type=" +
              this.type +
              "&query=" +
              q +
              "&qty=" +
              1000 +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            this.options = response.data;
          });
      }
    },
    clear_value() {
      this.code = "";
      this.value_ = "";
      this.selected = { value: "" };
      this.$emit("input", this.selected);
    },
  },
  computed: {
    options_filtered() {
      let result = [];

      let rexp = new RegExp(this.code_search, "i");
      let rexp2 = new RegExp(this.value_search, "i");
      this.options.filter((item) => {
        if (this.code_search === "" && this.value_search === "")
          result.push(item);
        if (
          (this.code_search !== "" && rexp.test(item.value)) ||
          (this.value_search !== "" && rexp2.test(item.display_text))
        )
          result.push(item);
      });
      return result;
    },
    _id() {
      return this._uid;
    },
    codes() {
      let result = [];
      this.options_filtered.forEach((option) => {
        result.push(option.value);
      });
      return result;
    },
    display_texts() {
      let result = [];
      this.options_filtered.forEach((option) => {
        result.push(option.display_text);
      });
      return result;
    },
    display_value() {
      if (this.selected.display_text)
        return (this.selected.value ? (this.selected.value + " | ") : "") + this.selected.display_text;
      return "";
    },
  },
  watch: {
    indata(){
      this.options = this.indata
    },
    // options_filtered(){
    //     if(this.options_filtered.length==1)
    //         this.selected_index = 0
    // },
    value() {
      this.selected = this.value;
    },
    code() {
      this.selected = { value: this.code, display_text: this.value_ };
      this.$emit("input", this.selected);
    },
    value_() {
      if (this.value_ === "") this.code = "";
      this.selected = { value: this.code, display_text: this.value_ };
      this.$emit("input", this.selected);
    },
    type() {
      this.load("");
    },
    selected() {
      this.$emit("input", this.selected);
    },
  },
};
</script>
<style scoped>
.clear-button {
  margin-top: 0;
  /* border-bottom: 1px solid rgb(203, 203, 203) !important; */
  /* border-bottom-color: rgb(203, 203, 203) !important; */
  color: rgb(203, 203, 203) !important;
  border-radius: 0;
  padding: 0 !important;
  height: 54px;
  margin-left: -29px;
  padding: 10px !important;
  z-index: 123;
}
.clear-button i,
.clear-button svg {
  /* margin-top: 6px; */
  color: #f44336 !important;
  fill: #f44336 !important;
}
</style>
<style>
.modal-dialog.unlimited-modal {
  max-width: unset !important;
}
.modal-dialog.modal-dialog.unlimited-modal .modal-content {
  margin: 0 auto;
}
</style>
